// Copyright (c) Docugami, Inc. All rights reserved.

import { CardHeader } from "components/cards/CardHeader";
import { ClearUnconfirmedBindingsButton } from "components/cards/ClearUnconfirmedBindingsButton";
import styled from "styled-components";

interface RepeatHeaderProps {
    entryId: string;
    folderId: string;
    count: number;
}

export const RepeatCardHeader = (props: RepeatHeaderProps): JSX.Element => {
    return (
        <CardHeader count={props.count}>
            {props.count !== 0 && <ClearUnconfirmedBindingsButton entryId={props.entryId} folderId={props.folderId} showLabel />}
        </CardHeader>
    )
}

const CellHeaderRoot = styled(CardHeader)`
    padding: 5px;
`;

export const RepeatCellHeader = (props: RepeatHeaderProps): JSX.Element => {
    return (
        <CellHeaderRoot count={props.count}>
            {props.count !== 0 && <ClearUnconfirmedBindingsButton entryId={props.entryId} folderId={props.folderId} showLabel />}
        </CellHeaderRoot>
    )
}
